/* RESPONSIBLE TEAM: team-automation-foundations */
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export const AgentType = {
  FIN: 'fin',
  FIN_SDR: 'fin_sdr',
  FIN_ECOMMERCE: 'fin_ecommerce',
  FIN_SUCCESS: 'fin_success',
  FIN_PROACTIVE: 'fin_proactive',
} as const;

export type AgentTypeValue = (typeof AgentType)[keyof typeof AgentType];

interface AgentTypeConfigEntry {
  icon: InterfaceIconName;
  containerClasses: string;
}

export const AGENT_TYPE_CONFIG: Record<AgentTypeValue, AgentTypeConfigEntry> = {
  [AgentType.FIN]: {
    icon: 'service-agent',
    containerClasses: 'bg-accent-fill-emphasis text-on-accent',
  },
  [AgentType.FIN_SDR]: {
    icon: 'salesforce-case',
    containerClasses: 'bg-beta-fill text-on-beta',
  },
  [AgentType.FIN_ECOMMERCE]: {
    icon: 'shopping-cart',
    containerClasses: 'bg-vis-mantis-40 text-on-success',
  },
  [AgentType.FIN_SUCCESS]: {
    icon: 'survey-filled',
    containerClasses: 'bg-vis-magenta-40 text-on-neutral',
  },
  [AgentType.FIN_PROACTIVE]: {
    icon: 'send',
    containerClasses: 'bg-vis-cyan-40 text-on-neutral',
  },
};

export const DEFAULT_AGENT_TYPE = AgentType.FIN;
